import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Pagination, SearchBar, TableItemsUsers } from "../../components";
import { fetchDataUsers, setPage } from "../../store/slices/authSlice";
import { openModal } from "../../store/slices/editModalSlice";
import { openModalDelete } from "../../store/slices/deleteModalUsersSlice";
import InfoModal from "../Modals/InfoModal";
import DeleteModalUsers from "../Modals/DeleteModal/DeleteModalUsers";
import EditModalUsers from "../Modals/EditModal/EditModalUsers";
import { fetchDataCategories } from "../../store/slices/apiCategorySlice";
import { FaRegCircleXmark } from "react-icons/fa6";
import { FiEye } from "react-icons/fi";
import { BiReset } from "react-icons/bi";
import Select from "react-select";
import { MdOutlineAddCircleOutline, MdDeleteOutline,MdOutlineAdd,MdAdd } from "react-icons/md";

import {
  activateGuestFromAdmin,
  getActiveCategoryUserId,
  getUserById,
  removeDriveSchoolFromUser,
  resetUserData,
  selectActiveCategoryUser,
} from "../../store/slices/authSlice";
import {
  getCurrentDateTime,
  getFutureDateTimeDay,
  formatDateString,
  isUserActive,
} from "../../util/time";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AddModalActivateUserCash from "../Modals/AddModalActivateUserCash";

const TableUsers = () => {
  const dispatch = useDispatch();
  const dataUser = useSelector((state) => state.auth.data);
  const userData = useSelector((state) => state.auth.userData);
  const currentPage = useSelector((state) => state.auth.currentPage);
  const totalCount = useSelector((state) => state.auth.totalCount);
  const [searchInput, setSearchInput] = useState("");
  const activeCategoryUser = useSelector(selectActiveCategoryUser);
  const editModalState = useSelector((state) => state.editModalUsers);
  const [openActiveModal, setOpenActiveModal] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [day, setDay] = useState("");
  const [id, setId] = useState("");
  const dataCategories = useSelector((state) => state.apiCategory.data);
  const [activity, setActivity] = useState(false);
  const [openResetModal, setOpenResetModal] = useState(false);
  const [resetUserId, setResetUserId] = useState(null);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [viewUserId, setViewUserId] = useState(null);
  const [openDeleteDriveSchoolModal, setOpenDeleteDriveSchoolModal] =
    useState(false);
  const [deleteDriveSchoolUserId, setDeleteDriveSchoolUserId] = useState(null);
  const [openActivateCashModal, setOpenActivateCashModal] = useState(false);
  const [activateCashUserId, setActivateCashUserId] = useState(null);
  const [activateCashDriveSchoolUserId, setActivateCashDriveSchoolUserId] = useState(null);
  const [activateCashUserSchoolId, setActivateCashUserSchoolId] = useState(null);
  const prevSearchRef = useRef("");


  const onSubmit = (e) => {
    e.preventDefault();

    const selectedQuestionCategoryIds = selectedCategories.map(
      (option) => option.value
    );

    const data = {
      userId: id,
      catId: JSON.stringify(selectedQuestionCategoryIds),
      activeStart: getCurrentDateTime(),
      activeEnd: getFutureDateTimeDay(day),
    };
    try {
      dispatch(activateGuestFromAdmin(data));
      setDay("");
      setSelectedCategories([]);
      toast.success("Kandidati u aktivizua me sukses");
    } catch (error) {
      console.log(error);
    }
  };

  const getActiveCategoryId = (userId) => {
    setActivity(!activity);
    try {
      dispatch(getActiveCategoryUserId(userId));
    } catch (error) {
      console.log(error);
    }
  };

  const handleOptionChange = (selectedOptions) => {
    setSelectedCategories(selectedOptions);
  };

  const handleEditItem = (id) => {
    dispatch(openModal(id));
  };

  const handleDeleteItem = (id) => {
    dispatch(openModalDelete(id));
  };

  useEffect(() => {
    dispatch(fetchDataCategories());
    dispatch(getUserById());
  }, []);

  useEffect(() => {
    if (prevSearchRef.current !== searchInput) {
      dispatch(setPage(1));
      prevSearchRef.current = searchInput;
      dispatch(fetchDataUsers({ page: 1, searchQuery: searchInput }));
    } else {
      dispatch(fetchDataUsers({ page: currentPage, searchQuery: searchInput }));
    }
  }, [searchInput, currentPage, dispatch]);
  
  
  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
  };
  

  const handlePageChange = (page) => {
    dispatch(setPage(page));
  };

  return (
    <div className="p-4 sm:p-6">
      <div className="flex flex-col sm:flex-row items-center justify-between pb-4 bg-white dark:bg-gray-900">
        <SearchBar
          searchInput={searchInput}
          handleSearchInputChange={handleSearchInputChange}
          handleSearchSubmit={handleSearchSubmit}
        />
      </div>
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg bg-white dark:bg-gray-800">
        <div className="hidden sm:block">
          <table className="min-w-full text-xs bg-gray-50  dark:bg-gray-700 dark:text-gray-400">
            <thead className="text-sm text-[#718EBF] bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-4 py-3 text-left">
                  Emri dhe Mbiemri
                </th>
                <th scope="col" className="px-4 py-3 text-left">
                  Numri Telefonit
                </th>
                <th scope="col" className="px-4 py-3 text-left">
                  Autoshkolla
                </th>
                <th scope="col" className="px-4 py-3 text-left">
                  Device ID
                </th>
                <th scope="col" className="px-4 py-3 text-left">
                  Aksionet
                </th>
              </tr>
            </thead>
            <tbody>
              {/* <TableItemsUsers dataUsers={dataUser} /> */}

              {dataUser?.data
                ?.filter((item) => item && item.name)
                .map((item) => (
                  <tr
                    key={item.id}
                    className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 text-xs sm:text-sm"
                  >
                    <td className="px-4 py-3 font-medium text-gray-900 whitespace-nowrap truncate max-w-[150px] dark:text-white">
                      {item.name}
                    </td>
                    <td className="px-4 py-3 truncate max-w-[150px]">
                      {item.phoneNumber}
                    </td>
                    <td className="px-4 py-3 truncate max-w-[180px]">
                      {item.driveSchoolName}
                    </td>
                    <td className="px-4 py-3 truncate max-w-[150px]">
                      {item.role === "user" ? "Autoshkoll" : item.deviceId}
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex flex-wrap items-center gap-2">
                        <button
                          onClick={() => {
                            setOpenActiveModal(!openActiveModal);
                            setId(item.id);
                          }}
                          className="text-sm"
                          title="Aktivizo (modal ekzistues)"
                        >
                          <MdOutlineAddCircleOutline
                            style={{
                              width: 23,
                              height: 23,
                              marginBottom: 3,
                              color: "#21C621",
                            }}
                          />
                        </button>
                        <button
                          onClick={() => {
                            setActivateCashUserId(item.id);
                            setActivateCashDriveSchoolUserId(item.driveSchoolUserId);
                            setOpenActivateCashModal(true);
                          }}
                          className="text-sm"
                          title="Aktivizo kategorinë "
                        >
                          <MdAdd
                            style={{
                              width: 23,
                              height: 23,
                              marginBottom: 3,
                              color: "red",
                            }}
                          />
                        </button>

                        <button
                          className="text-blue-500 text-sm"
                          onClick={() => getActiveCategoryId(item.id)}
                        >
                          <InfoModal
                            title="Info rreth testit"
                            name="Emri i testit"
                            categoryInInfo="Kategoria e testit"
                          />
                        </button>

                        <button
                          className="text-green-600 text-sm"
                          onClick={() => handleEditItem(item.id)}
                        >
                          <EditModalUsers
                            id={item.id}
                            title="Ndrysho Paswordin"
                            submitButtonText="Aktivizo"
                            durationName="Kohezgjatja"
                            subscriptionStatus="A eshte abonuar"
                            isOpen={editModalState[item.id] === true}
                          />
                        </button>

                        <button
                          className="text-red-500 text-sm"
                          onClick={() => handleDeleteItem(item.id)}
                        >
                          <DeleteModalUsers id={item.id} />
                        </button>

                        <button
                          onClick={() => {
                            setOpenResetModal(true);
                            setResetUserId(item.id);
                          }}
                          className="text-sm"
                        >
                          <BiReset
                            style={{
                              width: 23,
                              height: 23,
                              marginBottom: 3,
                              color: "#FF0004",
                            }}
                          />
                        </button>
                        <button
                          onClick={() => {
                            dispatch(getUserById(item.id));
                            setViewUserId(item.id);
                            setOpenViewModal(true);
                          }}
                          className="text-sm"
                        >
                          <FiEye
                            className="text-green-500 text-lg"
                            style={{ width: 23, height: 23, marginBottom: 3 }}
                          />
                        </button>

                        <button
                          onClick={() => {
                            setDeleteDriveSchoolUserId(item.id);
                            setOpenDeleteDriveSchoolModal(true);
                          }}
                          className="text-sm"
                        >
                          <MdDeleteOutline
                            className="text-red-500 text-lg"
                            style={{ width: 23, height: 23, marginBottom: 3 }}
                          />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        <div className="block sm:hidden space-y-4">
          {dataUser?.data
            ?.filter((item) => item?.name)
            .map((item) => (
              <div
                key={item.id}
                className="bg-white shadow rounded-lg p-4 text-sm space-y-2"
              >
                <p>
                  <strong>Emri:</strong> {item.name}
                </p>
                <p>
                  <strong>Numri:</strong> {item.phoneNumber}
                </p>
                <p>
                  <strong>Autoshkolla:</strong> {item.driveSchoolName}
                </p>
                <p>
                  <strong>Device ID:</strong>{" "}
                  {item.role === "user" ? "Autoshkoll" : item.deviceId}
                </p>

                <div className="flex flex-wrap gap-2 pt-2">
                  <button
                    onClick={() => {
                      setOpenActiveModal(true);
                      setId(item.id);
                    }}
                  >
                    <MdOutlineAddCircleOutline
                      className="text-green-600"
                      size={22}
                    />
                  </button>
                  <button
                          onClick={() => {
                            setActivateCashUserId(item.id);
                            setActivateCashDriveSchoolUserId(item.driveSchoolUserId);
                            setOpenActivateCashModal(true);
                          }}
                          className="text-sm"
                          title="Aktivizo kategorinë "
                        >
                          <MdAdd
                            style={{
                              width: 23,
                              height: 23,
                              marginBottom: 3,
                              color: "red",
                            }}
                          />
                        </button>
                  <button onClick={() => getActiveCategoryId(item.id)}>
                    <InfoModal
                      title="Info rreth testit"
                      name="Emri i testit"
                      categoryInInfo="Kategoria e testit"
                    />
                  </button>

                  <button onClick={() => handleEditItem(item.id)}>
                    <EditModalUsers
                      id={item.id}
                      title="Ndrysho Paswordin"
                      submitButtonText="Aktivizo"
                      durationName="Kohezgjatja"
                      subscriptionStatus="A eshte abonuar"
                      isOpen={editModalState[item.id] === true}
                    />
                  </button>

                  <button onClick={() => handleDeleteItem(item.id)}>
                    <DeleteModalUsers id={item.id} />
                  </button>

                  <button
                    onClick={() => {
                      setOpenResetModal(true);
                      setResetUserId(item.id);
                    }}
                  >
                    <BiReset className="text-red-500" size={22} />
                  </button>

                  <button
                    onClick={() => {
                      dispatch(getUserById(item.id));
                      setViewUserId(item.id);
                      setOpenViewModal(true);
                    }}
                  >
                    <FiEye className="text-green-500" size={22} />
                  </button>

                  <button
                    onClick={() => {
                      setDeleteDriveSchoolUserId(item.id);
                      setOpenDeleteDriveSchoolModal(true);
                    }}
                  >
                    <MdDeleteOutline className="text-red-500" size={22} />
                  </button>
                </div>
              </div>
            ))}
        </div>

        {activity && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 p-2">
            <div className="bg-white w-full max-w-3xl rounded-2xl shadow-lg p-4 sm:p-6 mx-2 sm:mx-4 overflow-y-auto max-h-[90vh]">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg sm:text-xl font-semibold text-gray-800">
                  Kategori Aktive
                </h2>
                <button
                  onClick={() => setActivity(false)}
                  className="text-gray-400 hover:text-gray-600 text-2xl font-bold"
                >
                  &times;
                </button>
              </div>

              <div className="overflow-x-auto border border-gray-200 rounded-lg">
                <table className="min-w-full text-sm text-gray-700">
                  <thead className="bg-gray-100 text-xs sm:text-sm uppercase font-semibold text-gray-600">
                    <tr>
                      <th className="px-4 py-3 text-left whitespace-nowrap">
                        Kategoria
                      </th>
                      <th className="px-4 py-3 text-left whitespace-nowrap">
                        Koha e Fillimit
                      </th>
                      <th className="px-4 py-3 text-left whitespace-nowrap">
                        Koha e Mbarimit
                      </th>
                      <th className="px-4 py-3 text-left whitespace-nowrap">
                        Statusi
                      </th>
                      <th className="px-4 py-3 text-left whitespace-nowrap">
                        Menyra e Pagesës
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {activeCategoryUser.map((item) => (
                      <tr key={item.id} className="hover:bg-gray-50">
                        <td className="px-4 py-3 font-medium whitespace-nowrap">
                          {item.name}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap">
                          {formatDateString(item.activeStart)}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap">
                          {formatDateString(item.activeEnd)}
                        </td>

                        <td className="px-4 py-3 whitespace-nowrap">
                          {isUserActive(item.activeStart, item.activeEnd) ? (
                            <span className="text-green-600 font-semibold">
                              Aktiv
                            </span>
                          ) : (
                            <span className="text-red-500 font-semibold">
                              Skaduar
                            </span>
                          )}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap">
                          {item.statusCash === 1
                            ? "Përmes Autoshkollës"
                            : "Me para në dorë"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {openActiveModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4">
            <div className="bg-gray-900 bg-opacity-40 absolute inset-0"></div>

            <div className="relative bg-white dark:bg-gray-800 rounded-lg shadow-lg w-full max-w-lg mx-auto overflow-y-auto max-h-[90vh]">
              <div className="p-4 sm:p-6 text-center">
                <h3 className="mb-4 text-lg sm:text-xl font-semibold text-gray-700 dark:text-gray-300">
                  Aktivizo
                </h3>

                <form className="space-y-5 text-start" onSubmit={onSubmit}>
                  <div>
                    <label
                      htmlFor="day"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Ditet:
                    </label>
                    <input
                      type="number"
                      name="day"
                      id="day"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                      placeholder="Ditet"
                      value={day}
                      onChange={(e) => setDay(e.target.value)}
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="selectedCategories"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Kategoria:
                    </label>
                    <Select
                      isMulti
                      name="selectedCategories"
                      id="selectedCategories"
                      value={selectedCategories}
                      onChange={handleOptionChange}
                      options={dataCategories.map((option) => ({
                        value: option.id,
                        label: option.name,
                      }))}
                      className="text-sm"
                      classNamePrefix="react-select"
                    />
                  </div>

                  <div className="flex justify-center">
                    <div className="flex flex-wrap gap-3 justify-center">
                      <button
                        type="submit"
                        className="text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-200 rounded-lg text-sm font-medium px-5 py-2.5 dark:bg-blue-700 dark:hover:bg-blue-600 dark:focus:ring-blue-500"
                      >
                        Aktivizo
                      </button>

                      <button
                        onClick={() => setOpenActiveModal(false)}
                        type="button"
                        className="text-gray-700 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-300 text-sm font-medium px-5 py-2.5 dark:bg-gray-600 dark:text-white dark:border-gray-500 dark:hover:bg-gray-700 dark:focus:ring-gray-500"
                      >
                        Anulo
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {openResetModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
            <div
              className="bg-gray-900 bg-opacity-40 absolute inset-0"
              onClick={() => setOpenResetModal(false)}
            ></div>

            <div className="relative bg-white rounded-lg shadow-lg w-full max-w-md p-6">
              <button
                type="button"
                onClick={() => setOpenResetModal(false)}
                className="absolute top-3 right-3 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-full w-8 h-8 flex justify-center items-center"
                aria-label="Close modal"
              >
                <FaRegCircleXmark style={{ width: 20, height: 20 }} />
              </button>

              <div className="text-center">
                <h3 className="mb-5 text-xl font-normal text-gray-500 dark:text-gray-400">
                  A jeni i sigurt?
                </h3>
                <button
                  className="bg-red-500 hover:bg-red-600 transition-colors rounded-full text-white px-6 py-2 text-sm font-semibold"
                  onClick={() => {
                    dispatch(resetUserData(resetUserId))
                      .unwrap()
                      .then(() =>
                        toast.success("Të dhënat u rivendosën me sukses")
                      )
                      .catch((err) => toast.error(`Gabim: ${err}`));
                    setOpenResetModal(false);
                  }}
                >
                  Reseto
                </button>
              </div>
            </div>
          </div>
        )}

        {openViewModal && dataUser && (
          <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
            <div
              className="bg-gray-900 bg-opacity-40 absolute inset-0"
              onClick={() => setOpenViewModal(false)}
            ></div>

            <div className="relative bg-white rounded-lg shadow-lg w-full max-w-md p-6">
              <button
                type="button"
                onClick={() => setOpenViewModal(false)}
                className="absolute top-3 right-3 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-full w-8 h-8 flex justify-center items-center"
                aria-label="Close modal"
              >
                <FaRegCircleXmark style={{ width: 20, height: 20 }} />
              </button>

              <div className="text-center">
                <h3 className="mb-4 text-xl font-semibold text-gray-700">
                  Detajet e përdoruesit
                </h3>

                <div className="text-sm text-gray-600 space-y-2 text-start">
                  {(() => { 
                    const deviceId = userData.role === "user" ? "Autoshkoll" : userData.deviceId;
                    return (
                      <p>
                        <strong>DeviceId:</strong>{" "}
                        {deviceId}
                      </p>
                    );
                  })()}
                </div>
              </div>
            </div>
          </div>
        )}

        {openDeleteDriveSchoolModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
            <div
              className="bg-gray-900 bg-opacity-40 absolute inset-0"
              onClick={() => setOpenDeleteDriveSchoolModal(false)}
            ></div>

            <div className="relative bg-white rounded-lg shadow-lg w-full max-w-md p-6">
              <button
                type="button"
                onClick={() => setOpenDeleteDriveSchoolModal(false)}
                className="absolute top-3 right-3 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-full w-8 h-8 flex justify-center items-center"
                aria-label="Close modal"
              >
                <FaRegCircleXmark style={{ width: 20, height: 20 }} />
              </button>

              <div className="text-center">
                <h3 className="mb-5 text-xl font-normal text-gray-500 dark:text-gray-400">
                  A jeni i sigurt që doni të fshini autoshkollën për këtë
                  përdorues?
                </h3>
                <div className="flex justify-center gap-4">
                  <button
                    className="bg-red-500 hover:bg-red-600 transition-colors rounded-full text-white px-6 py-2 text-sm font-semibold"
                    onClick={() => {
                      dispatch(
                        removeDriveSchoolFromUser(deleteDriveSchoolUserId)
                      )
                        .unwrap()
                        .then(() => {
                          toast.success("Autoshkolla u fshi me sukses");
                          setOpenDeleteDriveSchoolModal(false);
                        })
                        .catch((err) => {
                          toast.error(`Gabim: ${err}`);
                        });
                    }}
                  >
                    Po, Fshije
                  </button>

                  <button
                    className="bg-gray-300 hover:bg-gray-400 text-gray-800 rounded-full px-6 py-2 text-sm font-semibold"
                    onClick={() => setOpenDeleteDriveSchoolModal(false)}
                  >
                    Anulo
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        <Pagination
          currentPage={currentPage}
          totalCount={totalCount}
          onPageChange={handlePageChange}
        />
        <AddModalActivateUserCash
          isOpen={openActivateCashModal}
          onClose={() => setOpenActivateCashModal(false)}
          userId={activateCashUserId}
          driveSchoolUserId={activateCashDriveSchoolUserId}
          userSchoolId={activateCashUserSchoolId}
          onSuccess={() => {
            setOpenActivateCashModal(false);
            // Optionally refresh users or show a toast
          }}
        />
      </div>
    </div>
  );
};

export default TableUsers;
